<template>
  <div>
    <div class="dropdown dropdown-start dropdown-top">
      <div tabindex="0" role="button" class="btn">
        {{ $route.query.size ?? 24 }} / trang
      </div>
      <ul
        tabindex="-1"
        class="dropdown-content menu bg-base-100 rounded-box z-1 w-32 p-2 shadow-sm"
      >
        <li>
          <RouterLink
            onclick="document.activeElement.blur()"
            v-for="size in [12, 24, 48, 96]"
            :key="size"
            :to="{
              name: $route.name,
              query: {
                ...$route.query,
                page: 1,
                size: size,
              },
            }"
          >
            {{ size }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
